const jsonData = require("./langDict.json");
const jsonData2 = require("./customDict.json");
const cityJson = require("./cityDict.json");
export default {
  ...jsonData,
  ...jsonData2,
  ...cityJson,
};
